import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useApplicationStore = defineStore('application', () => {

	const appNotifications = ref([])

	function addNotify(payload) {
		let notify = {
			status: true,
			timeout: 2000,
			...payload,
		}
		appNotifications.value.push(notify)
	}

	function addSuccessNotify(payload = {}) {
		let notify = {
			color: 'succsess',
			...payload,
		}
		addNotify(notify)
	}

	function addErrorNotify(payload = {}) {
		let notify = {
			color: 'error',
			timeout: 3000,
			...payload,
		}
		addNotify(notify)
	}

	function $reset() {
		appNotifications.value = []
	}

	return {
		appNotifications,
		addErrorNotify,
		addSuccessNotify,
		$reset,
	}

})
